<template>
  <div class="animated fadeIn list-of-advance">
    <b-card>
      <div slot="header">
        List of Cash Advance Request
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <!-- <b-button variant="primary mr-1" @click="payment()">Payment History</b-button> -->
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter = !showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
            <b-form-input v-model="tblData.uraian"></b-form-input>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                <b-form-input v-model="tblData.nomor" placeholder="Request Number"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend><span class="pt-2">Input By &nbsp;</span></b-input-group-prepend>
                <b-form-input v-model="tblData.createby"></b-form-input>
                <b-input-group-prepend><span class="pt-2">Pay To &nbsp;</span></b-input-group-prepend>
                <b-form-input v-model="tblData.dibayarke" placeholder="Pay to"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" style="width: 23% !important"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" style="width: 23% !important"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <!-- <b-row>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend><label>Cash Advance Acc.</label></b-input-group-prepend>
                <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend><span class="pt-2">Acc. Name&nbsp;</span></b-input-group-prepend>
                <b-form-input v-model="tblData.namaacc" placeholder="Account Name"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label class="text-right">Payment Status</label></b-input-group-prepend>
                <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.paymentStatus" style="padding: 0 !important"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><span class="pt-2">Settlement (PJ)</span></b-input-group-prepend>
                <b-form-select v-model="tblData.jenisSettlOS" :plain="true" :options="dataList.settlStatus"></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="text-right">Advance Group</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.jenisAdv" :plain="true" :options="postGroups"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend><label>Advance Acc.#</label></b-input-group-prepend>
                <b-form-input v-model="tblData.kodeacc" placeholder="CashAdvance Account"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label class="text-right">Approval Status</label></b-input-group-prepend>
                <b-form-select v-model="tblData.statuswf" :plain="true" :options="dataList.approvalStatus"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-button class="btn btn-success ml-1" @click="search()"> Apply Filter</b-button>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear Filter </b-button>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(selected)="data">
          <input name="selectjurnal" type="checkbox" @change="checkedjurnal($event, data.item)" :data-advanKey="data.item.advanKey" :checked="ischeckedjurnal(data.item.advanKey)" />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
          <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
            <i class="fa fa-eraser"></i>
          </a>
        </template>
        <template v-slot:cell(action)="data">
          <b-dropdown dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret size="sm" style="margin: -10px">
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item
              @click="rowEdit(data.item)"
              href="#"
              :disabled="data.item.posting == 1 || (data.item.nomorbank || '') != '' || (use_wfservice==1 && ((data.item.send2wf == 1 && data.item.isreviewed == 0) || (data.item.send2wf == 1 && data.item.iscomplete == 1)))"
              style="padding: 0 !important"
              >Edit</b-dropdown-item
            >
            <b-dropdown-item @click="rowPrintpb(data.item)" href="#" :disabled="data.item.outstand == 0" style="padding: 0 !important">Perintah Bayar</b-dropdown-item>
            <b-dropdown-item @click="rowPrint(data.item)" href="#" :disabled="data.item.posting == 0" style="padding: 0 !important">Print</b-dropdown-item>
            <b-dropdown-item @click="rowDel(data.item)" href="#" style="padding: 0 !important"> Delete</b-dropdown-item>
            <b-dropdown-item @click="rowAttachment(data.item)" href="#" style="padding: 0 !important">Attachment</b-dropdown-item>
          </b-dropdown>
        </template>
        <template v-slot:cell(tglRequ)="data">
          {{ data.item.tglRequ | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(tranbank_tanggal)="data">
          {{ data.item.tranbank_tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(jumlah)="data">
          {{ data.item.jumlah | numFormat }}
        </template>
        <template v-slot:cell(nilaiByr)="data">
          {{ data.item.nilaiByr | numFormat }}
        </template>
        <template v-slot:cell(advSettlAmt)="data">
          <span v-if="data.item.advSettlAmt">{{ data.item.advSettlAmt | numFormat }}</span>
        </template>
        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>
        </template>
        <template v-slot:cell(download)="data">
          <b-link @click.stop="getAttachment(data.item)"><i class="fa fa-paperclip"></i></b-link>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to <span v-if="tblData.page * tblData.limit > tblData.total">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" style="margin-top: 0 !important">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit" size="sm" style="width: 80px" />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>

    <b-modal v-model="showAttachment" header-bg-variant="primary" title="Attachment" size="lg" :centered="true" ok-only>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Requesition No.</label></b-input-group-prepend>
            <b-form-input v-model="model.nomor" readonly></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="report-wraper">
        <table width="100%">
          <thead>
            <tr>
              <th width="200px">Attached Date</th>
              <th>File Name</th>
              <th width="100px">Attached By</th>
              <th width="40px">action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in attachmens" :key="row.attachmentKey">
              <td>{{ row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}</td>
              <td>
                <b-link @click="attachmentDownload(row)">{{ row.attchFileNm }}</b-link>
              </td>
              <td>{{ row.createby }}</td>
              <td>
                <div class="text-center" v-if="model.iscomplete == 0">
                  <a href="javascript:void(0)" class="text-danger" @click="delAttachment(row)">
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div no-body v-if="model.iscomplete == 0">
        <label>Add Attachment</label>
        <b-form-file v-model="file" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
        <b-row class="mt-1">
          <span class="p-2"
            >Selected File: <strong>{{ file ? file.name : "" }}</strong> Filesize:{{ bytesToKB.showFileSize(file) }}</span
          >
          <b-button variant="success" @click="attachmentSave" class="sm" v-if="file"><i class="fa fa-paperclip"></i> Add Attachment</b-button>
        </b-row>
      </div>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-advance {
  table {
    td:nth-child(1) {
      width: auto;
    }

    td:nth-child(2) {
      width: auto;
    }

    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }

  .input-group {
    .input-group-prepend {
      label {
        width: 110px !important;
      }
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import task from "../../apis/task";
import advance from "../../apis/advance";
import dropdown from "../../data/dropdown";
import bytesToKB from "../../libs/filesize-byte2kb";
import toastr from "mini-toastr";
import { mapState } from "vuex";
toastr.init();

export default {
  components: { Loading },
  data() {
    return {
      bytesToKB,
      showFilter: false,
      showDelConfirm: false,
      showAttachment: false,
      file: null,
      attachmens: [],
      isLoading: false,
      showReport: false,
      reportUrl: null,
      model: {},
      items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: "",
        tgl2: moment().format("YYYY-MM-DD"),
        sortBy: "tglRequ",
        sortDesc: false,
        DimCol: "Dim1",
        outstand: "",
        jenisSettlOS: "",
        jenisAdv: "",
        statuswf: "111",
      },
      use_wfservice: 0,
      postGroups: [],
      selected: [],
      dataList: {
        YesNoAll: dropdown.YesNoAll,
        approvalStatus: dropdown.approvalStatus,
        paymentStatus: [
          { value: "1", text: "OUTSTANDING" },
          { value: "0", text: "PAID(LUNAS)" },
          { value: "", text: "--ALL--" },
        ],
        settlStatus: [
          { value: "1", text: "DONE" },
          { value: "0", text: "NOT YET" },
          { value: "", text: "--ALL--" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["user", "dimension", "filter"]),
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:50px",
          thClass: "text-center",
        },
        {
          key: "selected",
          label: "",
          thStyle: "width:20px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "nomor",
          thStyle: "width:100px",
          label: "Request Number",
          sortable: true,
        },
        {
          key: "namaAdvan",
          label: "Advance Group",
          sortable: true,
        },
        {
          key: "tglRequ",
          thStyle: "width:90px",
          label: "Request Date",
          sortable: true,
        },
        {
          key: "keterangan",
          label: "Description",
          sortable: true,
        },
        {
          key: "crewinfo",
          label: "Request By",
          sortable: true,
        },
        {
          key: "dibayarke",
          label: "Paid to",
          sortable: true,
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "$,¥",
          sortable: true,
        },
        {
          key: "jumlah",
          label: "Request Amount",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "download",
          label: "Attach",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "issuccess",
          label: "Approval Status",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nomorbank",
          label: "Trx.Bank/Cash#",
          sortable: true,
        },
        {
          key: "tranbank_tanggal",
          label: "Paid Date",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "nilaiByr",
          label: "Paid",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nomorSttl",
          label: "Settlement#",
          sortable: true,
        },
        {
          key: "advSettlAmt",
          label: "Settlement Amt.",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
      ];
      const dims = this.dimension;
      for (let i = 0; i < dims.length; i += 1) {
        fields.push({
          key: `${dims[i].value}Txt`,
          // thStyle: "width:100px",
          label: dims[i].text,
          sortable: true,
        });
      }
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      // this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    "user.tglaktif": function (newVal) {
      this.tblData.tgl1 = newVal;
    },
  },
  created: async function () {
    this.use_wfservice = this.user.use_wfservice;
    this.tblData.tgl1 = this.user.tglaktif;
    const [postGroups, approvalConfig] = await Promise.all([advance.advancegroup(), advance.approvalConfig()])
    this.postGroups = postGroups;
    this.postGroups.unshift({ value: "", text: "All" });
    console.log("approvalConfig : ", approvalConfig);
    if (!approvalConfig) this.use_wfservice = 0;
    console.log("use_wfservice : ", this.use_wfservice);
  },
  methods: {
    attachmentDownload: async function (fl) {
      this.isLoading = true;
      try {
        await advance.attachmentDownload(fl);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    ischeckedjurnal(val) {
      const findjv = this.selected.find((x) => x === val);
      if (findjv) {
        return "checked";
      } else {
        return "";
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach((element) => {
        element.checked = false;
      });
      // $('[name="selectjurnal"]').each(function() {
      //     $(this).prop("checked", false);
      //   });
    },
    checkedjurnal(item, record) {
      this.rowClicked(record);
      const advanKey = item.target.attributes["data-advanKey"].value;
      if (item.target.checked) {
        const findjv = this.selected.find((x) => x === advanKey);
        if (!findjv) {
          this.selected.push(advanKey);
        }
      } else {
        const findIdx = this.selected.findIndex((x) => x === advanKey);
        this.selected.splice(findIdx, 1);
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      const filter = this.filter;
      let filtered = false;
      for (var key in filter.advreqlist) {
        this.tblData[key] = filter.advreqlist[key];
        filtered = true;
      }
      if (filtered === true) {
        this.tblData.tgl1 = filter.advreqlist.tgl1 || "";
        this.tblData.tgl2 = filter.advreqlist.tgl2 || "";
        this.showFilter = filtered;
        delete filter.advreqlist;
        this.$store.commit("filter", filter);
        // this.$store.commit("filter", {});
      }
      this.isLoading = true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.DimColInfo = (this.dimension.find((d) => d.value === this.tblData.DimCol) || {}).text;

      try {
        const list = await advance.list(this.tblData);
        this.items = list;
        this.isLoading = false;
        return list;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    search() {
      this.tblData.page = 1;
      this.refresh();
    },
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.kodeaccc = "";
      this.tblData.namaacc = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.dibayarke = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    saveFilter() {
      const keys = ["uraian", "DimCol", "DimVal", "tgl1", "tgl2", "outstand", "nomor", "createby", "dibayarke", "kodeacc", "namaacc", "isProject", "crewkey", "crewname"];
      let filtered = false;
      const advreqlist = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          advreqlist[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        advreqlist.page = this.tblData.page;
        advreqlist.limit = this.tblData.limit;
        advreqlist.sortBy = this.tblData.sortBy;
        advreqlist.sortDesc = this.tblData.sortDesc;
        this.filter.advreqlist = advreqlist;
        this.$store.commit("filter", this.filter);
      }
    },
    rowAttachment(record) {
      this.model = record;
      this.getAttachment(record);
    },
    getAttachment: async function (record) {
      try {
        this.model = record;
        this.isLoading = true;
        const data = await task.getAttachment({ taskkey: record.advanKey });
        this.attachmens = data;
        this.showAttachment = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    attachmentSave: async function (evt) {
      evt.preventDefault();
      if (this.invalidFile) {
        console.log("validation : ", this.$v.file);
        console.log("model : ", this.file);
        //   this.showAddAttachment=true;
        toastr.error("Please choose a file");
      } else {
        toastr.info(`Attachment Save`);
        this.isLoading = true;
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          formData.append("filename", this.file.name);
          formData.append("tablekey", this.model.advanKey);
          formData.append("tableName", "advance");
          formData.append("filesize", bytesToKB.showFileSize(this.file));
          const response = await task.attachmentSave(formData);
          console.log("response : ", response);
          const data = await task.getAttachment({ taskkey: this.model.advanKey });
          this.attachmens = data;
          this.file = null;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    attachmentDownload: async function (fl) {
      this.isLoading = true;
      try {
        await task.attachmentDownload(fl);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    delAttachment: async function (obj) {
      const pesan = `Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal
        .msgBoxConfirm(pesan, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value == true) {
            this.isLoading = true;
            try {
              await task.delAttachment(obj);
              const data = await task.getAttachment({ taskkey: this.model.advanKey });
              this.attachmens = data;
              this.isLoading = false;
            } catch (error) {
              this.isLoading = false;
              console.log("error : ", error);
              if (error.sql) {
                toastr.error(error.sql, "ERROR MESSAGE", 10000);
              } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
              } else if (error.message) {
                toastr.error(error.message, "ERROR MESSAGE", 10000);
              } else {
                toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
              }
            }
          }
          // this.close();
        })
        .catch((err) => {
          // An error occurred
        });
    },

    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
      this.posting();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.print();
    },
    rowPrintpb(record) {
      this.rowClicked(record);
      this.printpb();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    add() {
      this.saveFilter();
      router.push({ name: "advance.requestfrm" });
    },
    edit: function () {
      if (this.model.advanKey) {
        this.saveFilter();
        router.push({ name: "advance.requestfrm", params: { advanKey: this.model.advanKey } });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model.advanKey) {
          if (this.model.send2wf == 1 || this.model.posting == 1) {
            if (this.model.nilaiByr) {
              toastr.warn("Cash Advance sudah dibayar tidak boleh dihapus!");
              return;
            }
          }
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function () {
      this.isLoading = true;
      await advance.remove(this.model);
      this.refresh();
      // const index= this.items.findIndex(r => (r.advanKey==this.model.advanKey));
      // this.items.splice(index, 1);
      this.isLoading = false;
    },
    rowClicked(record, index) {
      console.log("record", record);
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    payment: function () {
      if (this.model.advanKey) {
        this.saveFilter();
        router.push({ name: "advance.paymview", params: { advanKey: this.model.advanKey } });
        this.showUploadFrm = true;
      } else {
        toastr.warn("Please select a row that want to be viewed!");
      }
    },
    print: async function () {
      if (this.model.advanKey) {
        try {
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await advance.print(this.model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    printpb: async function () {
      if (this.model.advanKey) {
        try {
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await advance.printpb(this.model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    printpbselected: async function () {
      if (this.selected) {
        try {
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await advance.printpbmultiple(this.selected);
        } catch (error) {
          console.log(error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select row(s) that want to be Printed!");
      }
    },

    exportxls: async function () {
      this.isLoading = true;
      try {
        this.tblData.DimColInfo = (this.dimension.find((d) => d.value === this.tblData.DimCol) || {}).text;
        const response = await advance.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    close() {
      router.push("/advance/home");
    },
  },
};
</script>
